import { useDiaryInvalidation } from "@/features/diaries/api/diaryInvalidation";
import {
	useCountBySettingsQuery,
	useDiariesBySettingsQuery,
} from "@/features/diaries/api/diaryQueries";
import type { PatientsSearchT } from "@/routes/_app/patients";
import { useSearch } from "@tanstack/react-router";

export function useRefetchPatientsData() {
	const search = useSearch({ strict: false }) as PatientsSearchT;
	const { refetch: refetchDiaries } = useDiariesBySettingsQuery(search);
	const { refetch: refetchCount } = useCountBySettingsQuery(search);
	const { invalidateAll } = useDiaryInvalidation();

	const refetchPatientsData = async () => {
		console.log("refetching patients data");
		await Promise.all([refetchDiaries(), refetchCount()]);
		invalidateAll();
	};

	return refetchPatientsData;
}
